import { MAX_RANGE_DAYS } from "../../services/billableConversionsExportService";
import { daysInRange } from "../../utils/dateUtils";

// Shared by the QuickBooks page's CSV tabs.

export const fieldLabelStyle = { display: "block", fontSize: 12, fontWeight: 600, color: "#3E3E3E", marginBottom: 6 };
export const fieldInputStyle = { padding: "8px 10px", border: "1px solid #CFCFCF", borderRadius: 8, fontSize: 13, color: "#151515", background: "#FFFFFF" };

export function browserDownload(filename, content) {
  const url = URL.createObjectURL(new Blob([content], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoking right after click() can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function rangeError(start, end) {
  if (!start || !end) return "Pick both dates.";
  if (start > end) return "The start date must be on or before the end date.";
  if (daysInRange(start, end) > MAX_RANGE_DAYS) return `Pick at most ${MAX_RANGE_DAYS} days.`;
  return null;
}
